<template lang="pug">
.product-item
  template(v-if="item.isChild")
    .d-flex.align-center.pl-2
      v-icon(size="18" color="neutral700" style="margin-bottom: 6px;") $yzi-corner-down-right
      .text-sm.ml-2 {{ item.productItem.name }}
  template(v-else)
    div.d-flex.py-2(v-if="item.editable" :style="expandedStyle")
      treatment-product-item-dropdown(style="width: 200px" :item="item" :isOTC="isOTC" :isError="isError" :errorMessage="errorMessage" @dropdownOpenClosed="$emit('dropdownOpenClosed', $event)" @changed="$emit('changed')")
      template(v-if="!item.productItem")
        .d-flex.align-center
          .text-sm.font-semibold.py-2.text-center.mx-3 OR
          v-btn.button-xs.neutral700--text.underline(text @click="$emit('addBulk')") Add items in bulk
    div.clickable(v-else-if="item.productItem")
      template(v-if="isDocument")
        .d-flex.justify-space-between.align-center
          .text-sm.truncate(style="max-width: 200px;") {{ item.productItem.name }}
          v-btn.button-sm(text small @click.stop="$emit('editDocument')")
            v-icon.mr-1(small color="info500") mdi-pencil
            .text-sm.shrink.info500--text.font-normal {{ $t('edit') }}
      template(v-else)
        .text-sm.font-medium.danger500--text(v-if="item.error") {{ item.productItem.name }}
        .text-sm(v-else) {{ item.productItem.name }}
</template>

<script>
import { mapGetters } from 'vuex'
import TreatmentProductItemDropdown from '@/components/clinic/consultation/treatments/treatmentTableItems/TreatmentProductItemDropdown.vue'

export default {
  components: {
    TreatmentProductItemDropdown,
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    autofocus: {
      type: Boolean
    },
    isOTC: {
      type: Boolean
    },
    isOpeningDropdown: {
      type: Boolean
    }
  },
  data() {
    return {
      isError: false,
      errorMessage: ''
    }
  },
  watch: {
    item: {
      handler(newValue) {
        // Check incomplete treatment
        if (newValue.productItem && newValue.inProgress) {
          this.isError = true
          this.errorMessage = 'Please choose price tier'
        } else {
          this.isError = false
          this.errorMessage = ''
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      isHq: 'hq/getIsHq'
    }),
    isDocument () {
      return this.item.productItem.type === 'documents'
    },
    expandedStyle () {
      if (!this.item.productItem) return 'width: 400px'
      
      return ''
    }
  },
};
</script>

<style lang="scss" scoped>
</style>